export class ObjectHelper {
  static isEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 && obj.constructor === Object : true;
  }

  static clearObject(obj: any): any {
    Object.keys(obj).forEach(key => (obj[key] = undefined));
    return obj;
  }
}
